/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Warning_Waist_FallbackInputs */

const en_us2_body_assessment_warning_waist_fallback = /** @type {(inputs: Body_Assessment_Warning_Waist_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your waist wasn't clearly defined in the outline and was filled in by interpolation. Wear tight clothing and keep your arms away from your body.`)
};

const pt_br2_body_assessment_warning_waist_fallback = /** @type {(inputs: Body_Assessment_Warning_Waist_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cintura não ficou bem definida no contorno e foi preenchida por interpolação. Use roupa justa e mantenha os braços afastados do corpo.`)
};

const es_419_body_assessment_warning_waist_fallback = /** @type {(inputs: Body_Assessment_Warning_Waist_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cintura no quedó bien definida en el contorno y se completó por interpolación. Usa ropa ajustada y mantén los brazos separados del cuerpo.`)
};

const pt_pt2_body_assessment_warning_waist_fallback = /** @type {(inputs: Body_Assessment_Warning_Waist_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cintura não ficou bem definida no contorno e foi preenchida por interpolação. Usa roupa justa e mantém os braços afastados do corpo.`)
};

const fr_fr2_body_assessment_warning_waist_fallback = /** @type {(inputs: Body_Assessment_Warning_Waist_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta taille n'était pas bien définie sur la silhouette et a été complétée par interpolation. Porte des vêtements moulants et garde les bras écartés du corps.`)
};

const de_de2_body_assessment_warning_waist_fallback = /** @type {(inputs: Body_Assessment_Warning_Waist_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Taille war im Umriss nicht klar erkennbar und wurde interpoliert. Trag eng anliegende Kleidung und halte die Arme vom Körper weg.`)
};

const it_it2_body_assessment_warning_waist_fallback = /** @type {(inputs: Body_Assessment_Warning_Waist_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La vita non era ben definita nella sagoma ed è stata ricavata per interpolazione. Indossa abiti aderenti e tieni le braccia staccate dal corpo.`)
};

/**
* | output |
* | --- |
* | "Your waist wasn't clearly defined in the outline and was filled in by interpolation. Wear tight clothing and keep your arms away from your body." |
*
* @param {Body_Assessment_Warning_Waist_FallbackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_waist_fallback = /** @type {((inputs?: Body_Assessment_Warning_Waist_FallbackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_Waist_FallbackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_waist_fallback(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_waist_fallback(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_waist_fallback(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_waist_fallback(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_waist_fallback(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_waist_fallback(inputs)
	return en_us2_body_assessment_warning_waist_fallback(inputs)
});
export { body_assessment_warning_waist_fallback as "body-assessment.warning.waist_fallback" }